// extracted by mini-css-extract-plugin
export default {"formLabel":"ForgotPasswordForm_formLabel__cl5Wo","formAlert":"ForgotPasswordForm_formAlert__pP0Xv","submitButtonContainer":"ForgotPasswordForm_submitButtonContainer__vl8BI"};